import { View, Text, Pressable, Linking } from "react-native";
import {
  ExternalLink,
  Facebook,
  Instagram,
  Linkedin,
  MessageCircle,
  Music,
  Podcast,
  Twitter,
  Youtube,
  type LucideIcon,
} from "lucide-react-native";
import type {
  ProviderSocialLink,
  ProviderSocialPlatform,
} from "@louise/providers/providers.types";
import { EMBER } from "../../../onboarding/theme";

import {
  pressLabel,
  usePressCapture,
} from "@src/packages/analytics/usePressCapture";
const SOCIAL_LINK_LABELS: Record<ProviderSocialPlatform, string> = {
  instagram: "Instagram",
  youtube: "YouTube",
  facebook: "Facebook",
  tiktok: "TikTok",
  linkedin: "LinkedIn",
  x: "X",
  whatsapp: "WhatsApp",
  podcast: "Podcast",
};

const SOCIAL_LINK_ICONS: Record<ProviderSocialPlatform, LucideIcon> = {
  instagram: Instagram,
  youtube: Youtube,
  facebook: Facebook,
  tiktok: Music,
  linkedin: Linkedin,
  x: Twitter,
  whatsapp: MessageCircle,
  podcast: Podcast,
};

export function SocialLinkPills({ links }: { links: ProviderSocialLink[] }) {
  const capturePress = usePressCapture("SocialLinkPills");
  const visibleLinks = links.filter((link) => link.url);
  if (visibleLinks.length === 0) return null;

  return (
    <View style={{ flexDirection: "row", flexWrap: "wrap", gap: 8 }}>
      {visibleLinks.map((link) => {
        const Icon = SOCIAL_LINK_ICONS[link.platform] ?? ExternalLink;
        const label = link.label ?? SOCIAL_LINK_LABELS[link.platform];

        return (
          <Pressable
            key={`${link.platform}-${link.url}`}
            onPress={() => {
              capturePress(pressLabel(label), "open_clinic_social_link");
              void Linking.openURL(link.url);
            }}
            style={{
              minHeight: 38,
              maxWidth: "100%",
              flexDirection: "row",
              alignItems: "center",
              gap: 7,
              borderRadius: 10,
              borderWidth: 1,
              borderColor: "rgba(255,255,255,0.45)",
              backgroundColor: "rgba(255,255,255,0.32)",
              paddingHorizontal: 12,
              paddingVertical: 8,
            }}
          >
            <Icon size={15} color={EMBER.colors.warm} strokeWidth={2} />
            <Text
              className="font-dm-sans"
              style={{
                fontSize: 13,
                fontWeight: "600",
                color: EMBER.colors.text,
                maxWidth: 180,
              }}
              numberOfLines={1}
            >
              {label}
            </Text>
            <ExternalLink
              size={12}
              color={EMBER.colors.textFaint}
              strokeWidth={2}
            />
          </Pressable>
        );
      })}
    </View>
  );
}
